import { push } from 'redux-first-history';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import ApiInstance from '../../../../../../helpers/apiInstance';
import actions from './actions';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import { keyByProperty } from '../../../../../../helpers/core';
import { t } from '../../../../../../i18n';

function* loadFormData({ payload }) {
  try {
    const { clientId, clientType } = payload;
    const formDataApi = new ApiInstance(`${clientType}/:clientId/accreditations/form_data`);

    const { formInfo } = yield all({
      formInfo: call(sendRequest, formDataApi.get, { pathParams: { clientId } }, notifications.REQUEST_ERROR),
    });

    if (formInfo?.status === 200 && formInfo?.data) {
      yield put(actions.loadFormDataSuccess({ formInfo: formInfo.data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* createAccreditation({ payload }) {
  try {
    const { editForm, clientId, clientType } = payload;
    const api = new ApiInstance(`${clientType}/:clientId/accreditations`);

    const propsArray = Object.values(editForm);
    const editFormData = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(
      sendRequest,
      api.put,
      {
        data: {
          accreditation_requirements: editFormData.accreditations.map(accreditation => ({
            accreditation_id: accreditation.id,
            position_ids: accreditation.positions,
            child_company_ids: accreditation.child_company_ids,
          })),
        },
        pathParams: {
          clientId,
        },
      },
      notifications.REQUEST_ERROR,
    );

    if (result.status === 200) {
      yield put(push(`/${clientType}/${clientId}?tab=accreditation`));

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.updated_successfully', {
            item: t('dash.clients.components.accreditations.accreditation_label'),
          }),
        }),
      );
    } else {
      yield put(actions.createAccreditationError(result));

      if (result.status === 422 && result.data?.validations?.accreditation_id) {
        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.error_headline'),
            type: 'error',
            message: `${t('dash.clients.components.accreditations.accreditation_label')}: ${
              result.data?.validations?.accreditation_id
            }`,
          }),
        );
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_DATA_REQUEST, loadFormData),
    takeEvery(actions.CREATE_DATA_REQUEST, createAccreditation),
  ]);
}
